import React from 'react';
import { HiChevronDown } from 'react-icons/hi';
import CandidateReviewModal from './CandidateReview';

const SelectionBanner = ({ selectedCandidates }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [showModal, setShowModal] = React.useState(false);
  const [action, setAction] = React.useState('');
  const total = selectedCandidates.length;

  const avgMatch = total
    ? Math.round(
        selectedCandidates.reduce(
          (sum, c) => sum + (c.primaryJob?.match || 0),
          0
        ) / total
      )
    : 0;

  const handleAction = (action) => {
    setAction(action);
    setShowModal(true);
    setIsOpen(false);
  };

  return (
    <>
      <div className="bg-[#6142E8] text-white py-6 flex flex-col md:flex-row justify-between items-center gap-6 shadow-lg pl-[30%] pr-[10%]">
        <div className="flex-1 flex flex-col justify-center">
          <h1 className="text-lg font-normal mb-2">
            {total > 0
              ? `Actions for ${total} Selected Candidate${total > 1 ? 's' : ''}`
              : 'Select Candidates to Take Action'}
          </h1>

          {total > 0 && (
            <p className="text-[#BCA4FF] text-xs opacity-80 max-w-xl leading-relaxed">
              Average match across selected candidates
            </p>
          )}
        </div>

        {total > 0 && (
          <div className="flex flex-col gap-3 min-w-[200px]">
            <div className="relative inline-block text-left">
              <button
                onClick={() => setIsOpen(!isOpen)}
                className="flex items-center justify-between w-52 px-4 py-2 text-sm md:text-base border border-white/40 rounded-lg bg-white/5 hover:bg-white/10 transition-colors"
              >
                <span>{action || 'Select Action'}</span>
                <HiChevronDown
                  className={`ml-2 text-xl md:text-2xl transition-transform ${
                    isOpen ? 'rotate-180' : ''
                  }`}
                />
              </button>

              {isOpen && (
                <div className="absolute bottom-full mb-2 right-0 w-44 bg-gradient-to-b from-[#6E3EF5] to-[#815FE2] border border-white/20 rounded-lg shadow-2xl overflow-hidden z-20">
                  {[
                    'Shortlist',
                    'Rejected',
                    'Call for Interview',
                    'Send Mail',
                  ].map((action) => (
                    <button
                      key={action}
                      onClick={() => handleAction(action)}
                      className="w-full text-left px-4 py-3 hover:bg-[#6142E8]/40 border-b border-white/10 transition-colors last:border-b-0"
                    >
                      {action}
                    </button>
                  ))}
                </div>
              )}
            </div>

            <div className="flex gap-2 text-[11px] uppercase tracking-wider text-purple-200/70">
              <span>Average Match {avgMatch}%</span>
            </div>
          </div>
        )}
      </div>
      <CandidateReviewModal
        open={showModal}
        onClose={() => setShowModal(false)}
        candidateArray={selectedCandidates}
      />
    </>
  );
};

export default SelectionBanner;
